import classnames from 'classnames';
import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconAlertCircle } from '#src/atoms/icons/system/iconAlertCircle.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { Score } from '#src/components/collections/Score/index.tsx';

const Wrapper = styled(Horizontal).attrs({ gap: 0.5, center: true })`
  padding: var(--half-unit) var(--intermediate-unit);
  color: var(--c-white);
  background-color: var(--c-nd-50);
  border-radius: var(--double-unit);
  transition: background-color 0.1s ease-in-out;
  &.listed {
    background: var(--c-surface-caution);
  }
`;

const ScoreButton = styled(ButtonBase)`
  &:hover,
  &:focus {
    ${Wrapper} {
      background-color: var(--c-nd-400-opaque);
      box-shadow: var(--shadow-300);
    }
  }
`;

type ContentProps = {
  score: number;
  listed?: boolean;
  rarity: Nullable<Rarity>;
};

type Props = {
  onClick?: (() => void) | false;
} & ContentProps;

const Content = ({ score, listed, rarity }: ContentProps) => {
  return (
    <Wrapper className={classnames({ listed })}>
      {!!listed && (
        <FontAwesomeIcon color="var(--c-yellow-400)" icon={iconAlertCircle} />
      )}
      <Score score={score} rarity={rarity} />
    </Wrapper>
  );
};

export const CardScore = (props: Props) => {
  const { onClick } = props;
  if (onClick)
    return (
      <ScoreButton onClick={onClick}>
        <Content {...props} />
      </ScoreButton>
    );
  return <Content {...props} />;
};
